<template>
  <div class="container contact-page">
    <h1>contact me</h1>
    <div class="contact-all">
      <div class="row">
        <div class="col-12 col-lg-4 contact-info">
          <h2>DON'T BE SHY !</h2>
          <div class="hr"></div>
          <p>
            Feel free to get in touch with me. I am always open to discussing
            new projects, creative ideas or opportunities to be part of your
            visions.
          </p>
          <p class="list">
            <font-awesome-icon
              class="i location"
              icon="fa-solid fa-map-location"
              color="#ffb400"
            />
            <span>ADDRESS POINT</span>
            Alexandria - Egypt
          </p>
          <p class="list">
            <font-awesome-icon
              class="i envelope"
              icon="fa-solid fa-envelope"
              color="#ffb400"
            />
            <span>MAIL ME</span>
            ibrahimmosstafa11@gmail.com
          </p>
          <p class="list">
            <font-awesome-icon
              class="i phone"
              icon="fa-solid fa-square-phone"
              color="#ffb400"
            />
            <span>CALL ME</span>
            +201013317307
          </p>
          <p class="list">
            <font-awesome-icon
              icon="fa-solid fa-square-phone"
              color="#ffb400"
              class="i phone"
            />
            <span>CALL ME</span>
            +201202061737
          </p>
          <div class="social">
            <a
              href="https://www.facebook.com/profile.php?id=100011728747407&mibextid=ZbWKwL"
              target="_blank"
              ><font-awesome-icon icon="fa-brands fa-square-facebook" />
            </a>
            <a
              href="https://www.instagram.com/ibrahimmostafa7518/"
              target="_blank"
              ><font-awesome-icon icon="fa-brands fa-square-instagram"
            /></a>
            <a
              href="https://www.linkedin.com/in/ibrahim-mosstafa-049b74174"
              target="_blank"
              ><font-awesome-icon icon="fa-brands fa-linkedin"
            /></a>
            <a href="https://github.com/ibrahimspider2020" target="_blank"
              ><font-awesome-icon icon="fa-brands fa-github"
            /></a>
          </div>
        </div>
        <div class="col-12 col-lg-8">
          <form ref="form" @submit.prevent="sendEmail">
            <div class="form-group">
              <input
                type="text"
                placeholder="YOUR NAME"
                required
                name="from_name"
              />
            </div>
            <div class="form-group">
              <input
                type="email"
                placeholder="YOUR EMAIL"
                required
                name="from_email"
              />
            </div>
            <div class="form-group">
              <textarea
                placeholder="YOUR MESSAGE"
                required
                style="height: 259px"
                name="message"
              ></textarea>
            </div>
            <div>
              <button class="button" type="submit">
                <span class="button-text"> Send Message</span
                ><span class="button-icon"
                  ><font-awesome-icon
                    icon="fa-solid fa-paper-plane"
                    size="lg"
                    color="#ddd"
                /></span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import emailjs from "emailjs-com";

export default {
  methods: {
    sendEmail() {
      emailjs
        .sendForm(
          "service_sv22j05",
          "template_ix2j1me",
          this.$refs.form,
          "4ye09DzGKXMCM45n6"
        )
        .then(
          (result) => {
            console.log("SUCCESS!", result.text);
            this.$router.push("/");
          },
          (error) => {
            console.log("FAILED...", error.text);
          }
        );
    },
  },
};
</script>
